export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const THEME_STORAGE_KEY = 'iota-theme';
export const FONT_SIZE_STORAGE_KEY = 'iota-font-size';

export const FONT_SIZE_OPTIONS = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  TINY: 'tiny',
};

export const THEME_COLORS = {
  ORANGE: '#d44401',
  BLUE: '#2a3478',
  BLUE_UNSAFE: '#28a8e0',
  LIGHT_BLUE_UNSAFE: '#9bcaed',
  LIGHT_GREY: '#f3f4f7',
  DARK_GREY: '#6c7589',
  INPUT_TEXT: '#727785',
  WHITE: '#fefefe',
  RED: '#d52d2d',
};

export const THEME_BACKGROUNDS = {
  DARK: {
    DEFAULT: '#0a0a0f',
    PAPER: '#1a1a1f',
    SECONDARY: '#1a1a1a',
    TERTIARY: '#262626',
  },
  LIGHT: {
    DEFAULT: '#ffffff',
    PAPER: '#ffffff',
    SECONDARY: '#f5f5f5',
    TERTIARY: '#f9f9f9',
  },
};

export const THEME_TEXT = {
  DARK: {
    PRIMARY: '#f9fafb',
    SECONDARY: '#d1d5db',
  },
  LIGHT: {
    PRIMARY: '#111827',
    SECONDARY: '#6b7280',
  },
};

export const THEME_BORDERS = {
  DARK: 'rgba(255, 255, 255, 0.1)',
  LIGHT: '#e5e7eb',
};

export const ANIMATION_DURATIONS = {
  FAST: '0.2s',
  NORMAL: '0.3s',
  SLOW: '0.5s',
};

export const ANIMATION_EASINGS = {
  EASE_IN_OUT: 'cubic-bezier(0.4, 0, 0.2, 1)',
  EASE_OUT: 'cubic-bezier(0.0, 0, 0.2, 1)',
  EASE_IN: 'cubic-bezier(0.4, 0, 1, 1)',
  SMOOTH: 'ease',
};
